<template>
  <div>
    <ConfirmDialog></ConfirmDialog>
    <slot name="body" @click="confirmDialog"></slot>
  </div>
</template>

<script>
import ConfirmDialog from "primevue/confirmdialog";

export default {
  components: {
    ConfirmDialog,
  },
  props: {
    message: {
      type: String,
    },
    icon: {
      type: String,
    },
    header: {
      type: String,
    },
  },
  methods: {
    confirmDialog(event) {
      this.$confirm.require({
        target: event.currentTarget,
        message: this.message,
        icon: this.icon,
        header: this.header,
        accept: () => {
          this.$emit("acceptDialog");
          //callback to execute when user confirms the action
        },
        reject: () => {
          this.$emit("rejectDialog");
          //callback to execute when user rejects the action
        },
      });
    },
  },
};
</script>
